module.exports = __webpack_public_path__ + "static/media/gosia.09b5a7e1.jpg";